import { render, staticRenderFns } from "./process-datasource-datasubject-transfering-legal-view.vue?vue&type=template&id=1cf64731"
import script from "./process-datasource-datasubject-transfering-legal-view.vue?vue&type=script&lang=js"
export * from "./process-datasource-datasubject-transfering-legal-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports